<mat-tab-group [selectedIndex]="1">
	<mat-tab label="Operational Data Collection Chart View">
		<div class="header-padding">
			<div class="header-container">
				<div class="report-info">
					<h2 class="report-title">Operational Data Collection</h2>
				</div>
				<div class="export-btn">
					<button mat-button class="export-pdf-disable primary cta" loadingDrillAndBlastCosts>
						<mat-icon class="svg-icon" svgIcon="pdfIcon"></mat-icon>
						Export as PDF
					</button>
				</div>
			</div>
		</div>
		<div class="content-container empty-image">
			<mat-icon svgIcon="empty-icon" class="empty-icon"></mat-icon>
			<div class="no-data"><h4>No Operational Data found for this section</h4></div>
		</div>
	</mat-tab>

	<mat-tab label="Operational Data Collection Table View">
		<div class="header-padding">
			<div class="header-container">
				<div class="report-info">
					<h2 class="report-title">Operational Data Collection</h2>
				</div>
				<div class="export-btn">
					<mat-form-field appearance="outline" class="search-field">
						<mat-label>Search</mat-label>
						<input matInput #searchInput (keyup)="applyFilter(searchInput.value)">
					</mat-form-field>
					<div class="custom-dropdown" [class.open]="dropdownOpen" (click)="toggleDropdown()">
						<div class="selected-option">
							{{ selectedType ? (selectedType | titlecase) : 'Select' }}
    						<span *ngIf="selectedType" class="arrow">&#9662;</span>
						</div>
						<ul class="options-list" *ngIf="dropdownOpen">
							<li *ngFor="let option of dropdownOptions"
								[class.selected]="selectedType === option"
								(click)="onSelect(option, $event)">
								{{ option | titlecase }}
								<span *ngIf="selectedType" class="clear-icon" (click)="clearSelection($event)">✖</span>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>

		<div class="content-container">
			<div class="table-content">
				<table class="data" mat-table [dataSource]="dataSource">
					<ng-container matColumnDef="datasetName">
						<th mat-header-cell *matHeaderCellDef>Project</th>
						<td mat-cell *matCellDef="let element">
							<ng-container *ngIf="siteDatasetLists?.length > 0 && selectedType == 'input' && element.isNewRow; else displayColumn">
								<mat-select (selectionChange)="onDatasetSelect($event)" class="select-project">
									<mat-option *ngFor="let dataset of siteDatasetLists" [value]="dataset">{{dataset.name}}</mat-option>
								</mat-select>
							</ng-container>

							<ng-template #displayColumn>
								<span class="select-project">{{element.datasetName}}</span>
							</ng-template>
						</td>
					</ng-container>

					<ng-container [matColumnDef]="col.key" *ngFor="let col of dataSourceSchema">
						<th mat-header-cell *matHeaderCellDef>
							{{col.label | UnitDisplayPipe: userUnitMeasurement : col.valueUnit}}
						</th>

						<td mat-cell *matCellDef="let element">
							<input [type]="col.type" matInput [ngModel]="element[col.key] | UnitConversionPipe: userUnitMeasurement : col.valueUnit " readonly="true" (click)="onFieldInputClick($event,col.readonly)" (ngModelChange)="onFieldInputChange(element, col.key, $event)" />
						</td>
					</ng-container>

					<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

					<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
				</table>
			</div>


			<div class="actions-container">
				<div class="actions-button" *ngIf="selectedType == 'input'">
					<ng-container *ngIf="selectedType == 'input'">
						<button
							*ngIf="siteId"
							mat-button
							class="add-row primary cta"
							(click)="onSaveOrAddRow()"
						>
							<mat-icon svgIcon="addIcon" class="svg-icon"></mat-icon>
							{{ isNewRow ? "Save" : "Add Row" }}
						</button>
						<button
							class="add-row primary cta"
							color="primary"
							*ngIf="isNewRow"
							(click)="removeRow()"
						>
							Remove
						</button>
					</ng-container>
				</div>
				<mat-paginator
					pageSize="30"
					[pageSizeOptions]="[30, 40]"
					hidePageSize="true"
				>
				</mat-paginator>
			</div>
		</div>
	</mat-tab>
</mat-tab-group>

<div class="loading-container" *ngIf="loadingOperationalInputDataCollection || loadingOperationalOutputDataCollection">
	<mat-spinner></mat-spinner>
</div>